<template>
  <div class="w-full">
    <div class="flex flex-col">
      <label
        :class="{
          'text-grey-300': isDark,
          'text-grey-dark': !isDark,
          'text-base': size === 'regular',
          'text-sm': size === 'small',
          'text-xs': size === 'x-small',
          'text-lg': size === 'full',
        }"
        >{{ $t('frontend_domain') }}</label
      >
      <gd-dropdown
        :options="domainsOfTheApp"
        @change="changedDomain"
        :dark="isDark"
        :placeholder="$t('frontend_gduikit_select_domain')"
        size="full"
        v-model="selectedDomain"
      >
      </gd-dropdown>
    </div>

    <div v-if="!fetchingSubdomains">
      <div class="flex flex-col mt-2" v-if="selectedDomain">
        <label
          :class="{
            'text-grey-300': isDark,
            'text-grey-dark': !isDark,
            'text-base': size === 'regular',
            'text-sm': size === 'small',
            'text-xs': size === 'x-small',
            'text-lg': size === 'full',
          }"
          >{{ $t('frontend_location') }}</label
        >
        <gd-dropdown
          :options="domainLocationsOfTheApp"
          @change="changedLocation"
          :dark="isDark"
          :placeholder="$t('frontend_gduikit_select_location')"
          size="full"
          v-model="selectedLocation"
        >
        </gd-dropdown>
      </div>

      <div
        class="flex flex-col mt-2"
        v-if="selectedDomain && selectedLocation == 1"
        :class="{
          'text-grey-300': isDark,
          'text-grey-dark': !isDark,
          'text-base': size === 'regular',
          'text-sm': size === 'small',
          'text-xs': size === 'x-small',
          'text-lg': size === 'full',
        }"
      >
        https://{{ this.selectedSubdomain }}
      </div>

      <div
        class="flex flex-col mt-2"
        v-if="selectedDomain && selectedLocation == 2"
      >
        <label
          :class="{
            'text-grey-300': isDark,
            'text-grey-dark': !isDark,
            'text-base': size === 'regular',
            'text-sm': size === 'small',
            'text-xs': size === 'x-small',
            'text-lg': size === 'full',
          }"
          >{{ $t('frontend_subdomain') }}</label
        >
        <gd-dropdown
          :options="subdomainsForDropdown"
          :dark="isDark"
          :placeholder="$t('frontend_gduikit_select_subdomain')"
          size="full"
          v-model="selectedSubdomain"
        >
        </gd-dropdown>
      </div>
    </div>

    <gd-modal name="add-subdomain-modal" title="Add New Subdomain">
      <div class="flex flex-col p-4">
        <div class="flex flex-row w-full mb-6">
          <div class="mt-2 mr-1">https://</div>
          <text-input
            v-model="newSubdomain.subdomain"
            attribute="Subdomain"
            value="newSubdomain.subdomain"
            placeholder="Subdomain"
          />
          <div class="mt-2">.{{ selectedDomainName }}</div>
        </div>
        <div class="flex flex-row w-full mb-6" v-if="errorMsg">
          <p class="mt-2 text-sm text-center text-red">{{ errorMsg }}</p>
        </div>
        <div class="flex flex-row w-full mb-6 mt-4 justify-end">
          <gd-button
            size="auto"
            class="px-4"
            primary
            @click="saveSubdomain"
            :loading="savingSubdomain"
            >{{ $t('frontend_gduikit_add_new_subdomain') }}</gd-button
          >
        </div>
      </div>
    </gd-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import directives from '../directives';
import mixins from '../mixins';
import GdDropdown from './Dropdown';
import GdModal from './Modal';
import GdButton from './Button';
import TextInput from './TextInput';

export default {
  name: 'DomainDropdown',
  components: {
    GdDropdown,
    GdModal,
    GdButton,
    TextInput,
  },
  directives,
  mixins: [mixins],
  props: {
    value: { default: '' },
    type: { default: 'pages' },
    dark: {},
    size: { default: 'regular' },
    domainFree: {
      type: Function
    }
  },
  data() {
    return {
      doneFetching: false,
      loading: false,
      fetchingDomains: false,
      fetchingSubdomains: false,
      savingSubdomain: false,
      selectedDomain: null,
      selectedLocation: 0,
      selectedSubdomain: null,
      errorMsg: '',
      newSubdomain: {
        type: 2,
        subdomain: '',
        application: this.type,
      },
      selectedDomainAvailable: true
    };
  },
  computed: {
    isDark() {
      return this.hasState('dark');
    },
    domainsOfTheApp() {
      if (this.fetchingDomains) {
        return [{ value: 0, text: 'Loading...' }];
      }

      return this.domains
        .filter((domain) => {
          return domain.subdomains.some((e) => e.application === this.type);
        })
        .map((domain) => ({ value: domain.id, text: domain.domain_name }));
    },
    domainLocationsOfTheApp() {
      if (this.fetchingSubdomains) {
        return [{ value: 0, text: 'Loading...' }];
      }
      const domainsLocationsOfTheApp = [];
      if (this.hasRootDomain && this.selectedDomainAvailable) {
        domainsLocationsOfTheApp.push({ value: 1, text: 'Root' });
      }

      domainsLocationsOfTheApp.push({ value: 2, text: 'Subdomain' });

      return domainsLocationsOfTheApp;
    },
    subdomainsForDropdown() {
      if (this.fetchingSubdomains) {
        return [{ value: 0, text: 'Loading...' }];
      }

      if (this.selectedDomain) {
        const subdomains = this.subdomains
          .filter((subdomain) => {
            return subdomain.application == this.type && subdomain.type == 2;
          })
          .map((subdomain) => ({
            value:
              subdomain.type == 1
                ? this.selectedDomainName
                : `${subdomain.subdomain}.${this.selectedDomainName}`,
            text:
              subdomain.type == 1
                ? this.selectedDomainName
                : `${subdomain.subdomain}.${this.selectedDomainName}`,
          }));

        subdomains.push({ value: -1, text: this.$t('frontend_gduikit_add_new_subdomain') });
        return subdomains;
      }
      return [];
    },
    hasRootDomain() {
      if (this.selectedDomainRecord) {
        return this.selectedDomainRecord.subdomains.some((e) => e.type == 1);
      }
      return false;
    },
    selectedDomainName() {
      if (this.selectedDomain) {
        return this.domains.find((domain) => domain.id == this.selectedDomain)
          .domain_name;
      }
      return '';
    },
    selectedDomainRecord() {
      if (this.selectedDomain) {
        return this.domains.find((domain) => domain.id == this.selectedDomain);
      }
      return null;
    },
    applicationName() {
      let application = 'GroovePages';
      if (this.type == 'pages') {
        application = 'GroovePages';
      } else if (this.type == 'sell-funnel' || this.type == 'sell-tracking') {
        application = 'GrooveSell';
      } else if (this.type == 'blog') {
        application = 'GrooveBlog';
      } else if (this.type == 'membership' || this.type == 'portal') {
        application = 'GrooveMember';
      } else if (this.type == 'kart') {
        application = 'GrooveKart';
      }

      return application;
    },
    ...mapGetters({
      domains: 'domains/domains',
      subdomains: 'subdomains/subdomains',
    }),
  },
  watch: {
    async selectedSubdomain() {
      if (this.doneFetching) {
        if (this.selectedSubdomain == -1) {
          this.selectedSubdomain = null;
          this.$root.$emit('modal-open', 'add-subdomain-modal');
        }
      }
      this.changedSubdomain();
    },
    async selectedDomain() {
      if (this.doneFetching) {
        this.fetchingSubdomains = true;

        await this.$store.dispatch('subdomains/getSubdomains', {
          id: this.selectedDomainRecord.id,
          application: this.applicationName,
        });

        this.fetchingSubdomains = false;
        this.selectedSubdomain = null;
        if (this.domainFree) {
          this.selectedDomainAvailable = await this.domainFree(this.selectedDomainRecord.domain_name, true)
        }
      }
    },
    async selectedLocation() {
      if (this.doneFetching) {
        if (this.selectedLocation == 1) {
          this.selectedSubdomain = this.selectedDomainName;
        } else {
          this.selectedSubdomain = null;
        }
      }
    },
  },
  async created() {
    await this.getUserDomains();

    const self = this;
    this.loadData().then((result) => {
      self.selectedDomain = result.domain;
      self.selectedLocation = result.location;
      self.selectedSubdomain = result.subdomain;
      self.$nextTick(() => {
        self.doneFetching = true;
      });
    });
  },
  methods: {
    async loadData() {
      const returnData = {
        domain: null,
        location: 0,
        subdomain: null,
      };

      if (this.value) {
        const psl = require('psl');
        const parsed = psl.parse(this.value);

        if (parsed) {
          const userSubdomain = parsed.subdomain;
          const userDomain = parsed.domain;
          const domainNameRecord = this.domains.find(
            (domain) => domain.domain_name == userDomain
          );
          if (domainNameRecord) {
            returnData.domain = domainNameRecord.id;
            this.fetchingSubdomains = true;
            await this.$store.dispatch('subdomains/getSubdomains', {
              id: domainNameRecord.id,
              application: this.applicationName,
            });
            this.fetchingSubdomains = false;
            let subdomainType = 1;

            if (userSubdomain) {
              subdomainType = 2;
            }

            returnData.location = subdomainType;

            if (subdomainType == 1) {
              returnData.subdomain = domainNameRecord.domain_name;
            } else {
              const selectedSubdomainRecord = domainNameRecord.subdomains.find(
                (subdomain) =>
                  subdomain.subdomain == userSubdomain &&
                  subdomain.type == subdomainType
              );
              if (selectedSubdomainRecord) {
                returnData.subdomain = `${selectedSubdomainRecord.subdomain}.${domainNameRecord.domain_name}`;
              }
            }
          }
        }
      }

      return returnData;
    },

    async saveSubdomain() {
      this.errorMsg = '';
      const MIN_LENGTH = 3;
      const MAX_LENGTH = 63;
      const ALPHA_NUMERIC_REGEX = /^[a-z][a-z\-]*[a-z0-9]*$/;
      const START_END_HYPHEN_REGEX = /\A[^-].*[^-]\z/i;
      const reservedNames = [
        'www',
        'ftp',
        'mail',
        'pop',
        'smtp',
        'admin',
        'ssl',
        'sftp',
      ];
      if (reservedNames.includes(this.newSubdomain.subdomain)) {
        this.errorMsg = this.$t('frontend_domain_dropdown_subdomain_cannot_be_reserved');
        return false;
      }

      // if is too small or too big...
      if (
        this.newSubdomain.subdomain.length < MIN_LENGTH ||
        this.newSubdomain.subdomain.length > MAX_LENGTH
      ) {
        this.errorMsg = `${this.$t('frontend_domain_dropdown_subdomain_must_have_a_length')} ${MIN_LENGTH} ${this.$t('frontend_and')} ${MAX_LENGTH} ${this.$t('frontend_domain_dropdown_characters')}`;
        return false;
      }

      // if subdomain is started/ended with hyphen or is not alpha numeric
      if (!ALPHA_NUMERIC_REGEX.test(this.newSubdomain.subdomain)) {
        if (
          this.newSubdomain.subdomain.indexOf('-') === 0 ||
          this.newSubdomain.subdomain.indexOf('-') ===
            this.newSubdomain.subdomain.length - 1
        ) {
          this.errorMsg = this.$t('frontend_domain_dropdown_subdomain_cannot_start');
        } else {
          this.errorMsg = this.$t('frontend_domain_dropdown_subdomain_must_be_alphanumeric');
        }
        return false;
      }

      this.savingSubdomain = true;
      const status = await this.$store.dispatch('subdomains/addSubdomain', {
        data: this.newSubdomain,
      });
      if (status == 'success') {
        this.selectedSubdomain = `${this.newSubdomain.subdomain}.${this.selectedDomainName}`;

        this.newSubdomain = {
          type: 2,
          subdomain: '',
          application: this.type,
        };

        this.$root.$emit('modal-close', 'add-subdomain-modal');
      } else if (status == 'duplicate') {
        this.errorMsg = this.$t('frontend_domain_dropdown_subdomain_unavailable');
      }

      this.savingSubdomain = false;

      return true;
    },

    async getUserDomains() {
      this.fetchingDomains = true;
      await this.$store.dispatch('domains/getDomains');
      this.fetchingDomains = false;
    },

    changedDomain() {
      this.selectedLocation = 0;
      this.selectedSubdomain = null;
      // this.changedSubdomain();
    },

    changedLocation() {
      // this.changedSubdomain();
    },

    changedSubdomain() {
      this.$emit('input', this.selectedSubdomain);
      this.$emit('change', this.selectedSubdomain);
      this.$emit('changeValue', this.selectedSubdomain);
    },
  },
};
</script>
